


































import Vue from 'vue';
import moment from 'moment';
import validationRules from '../mixin/validation-rules';

export default Vue.extend({
    data() {
        return {
            menu1: false,
            date: '',
        };
    },
    props: {
        value: {},
        label: { required: true, type: String },
        hint: {},
        required: { default: false },
    },
    computed: {
        formattedDate(): string {
            return this.date ? this.$options.filters?.date(this.date) : '';
        },
        validationRules(): any[] {
            return this.required
                ? [validationRules.getRequiredRule(this.label)]
                : [];
        },
    },
    methods: {
        onChange(e: any) {
            this.$emit('input', moment.utc(e).toDate());
        },
    },
    watch: {
        value: {
            handler: function (val) {
                this.date = val ? moment(val).format('YYYY-MM-DD') : '';
            },
            immediate: true,
        },
    },
});
